import { render, staticRenderFns } from "./InvoiceNew.vue?vue&type=template&id=40a376ce&"
import script from "./InvoiceNew.vue?vue&type=script&lang=js&"
export * from "./InvoiceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports